import type { FullPreset } from '../../../core/assistant/models/ViewRules';

/**
 * Built-in viewpoint presets for the network domain. Registered with
 * the shared `viewRulesStore` via `registerDomainPresets()` from
 * `registerNetworkDomain()` so that core assistant does not hardcode
 * domain-specific presets.
 *
 * Presets carry `domain: 'network'`; the store's `filterPresetsByDomain`
 * hides them from non-network diagrams.
 */
export const NETWORK_VIEW_PRESETS: FullPreset[] = [
  {
    id: 'builtin-network-topology',
    name: 'Network Topology',
    domain: 'network',
    rules: [
      { name: 'Primary Filter', conditions: [], logic: 'and', enabled: true, display: {}, order: 0 },
    ],
    createdAt: 0,
    requiredFields: [],
  },
  {
    id: 'builtin-network-security',
    name: 'Security Posture',
    domain: 'network',
    rules: [
      { name: 'Primary Filter', conditions: [], logic: 'and', enabled: true, display: {}, order: 0 },
      { name: 'Exposure Level', conditions: [], logic: 'and', enabled: true, display: { colorByField: { field: 'publicExposure' } }, order: 1 },
      {
        name: 'Unencrypted',
        conditions: [{ id: 'unencrypted', field: 'encrypted', operator: 'equals', value: false }],
        logic: 'and',
        enabled: true,
        display: { badge: { icon: 'ShieldAlert', color: '#dc2626', position: 'top-right', tooltip: 'Unencrypted at rest' } },
        order: 2,
      },
    ],
    createdAt: 0,
    requiredFields: [],
  },
  {
    id: 'builtin-network-compute',
    name: 'Compute Fleet',
    domain: 'network',
    rules: [
      { name: 'Primary Filter', conditions: [], logic: 'and', enabled: true, display: {}, order: 0 },
      { name: 'Instance State', conditions: [], logic: 'and', enabled: true, display: { colorByField: { field: 'state' } }, order: 1 },
      { name: 'Instance Type', conditions: [], logic: 'and', enabled: true, display: { label: { template: '{{instanceType}}', position: 'below' } }, order: 2 },
    ],
    createdAt: 0,
    requiredFields: [],
  },
  {
    id: 'builtin-network-data',
    name: 'Data & Storage',
    domain: 'network',
    rules: [
      { name: 'Primary Filter', conditions: [], logic: 'and', enabled: true, display: {}, order: 0 },
      { name: 'Engine', conditions: [], logic: 'and', enabled: true, display: { colorByField: { field: 'engine' } }, order: 1 },
      {
        name: 'Unencrypted Storage',
        conditions: [{ id: 'unencrypted-storage', field: 'encrypted', operator: 'equals', value: false }],
        logic: 'and',
        enabled: true,
        display: { badge: { icon: 'ShieldAlert', color: '#f59e0b', position: 'top-right', tooltip: 'Unencrypted at rest' } },
        order: 2,
      },
    ],
    createdAt: 0,
    requiredFields: [],
  },
  {
    id: 'builtin-network-iam',
    name: 'IAM Topology',
    domain: 'network',
    rules: [
      { name: 'Primary Filter', conditions: [], logic: 'and', enabled: true, display: {}, order: 0 },
      {
        name: 'Cross-Account Trust',
        conditions: [{ id: 'cross-account', field: 'crossAccountTrust', operator: 'equals', value: true }],
        logic: 'and',
        enabled: true,
        display: { colors: { borderColor: '#dc2626', backgroundColor: '#fef2f2' }, badge: { icon: 'AlertTriangle', color: '#dc2626', position: 'top-right', tooltip: 'Cross-account trust' } },
        order: 1,
      },
    ],
    createdAt: 0,
    requiredFields: [],
  },
];
